import { CONTENT_TOP_ELEMENT_ID } from 'pages/ParentHelper/components/History/components/Content/constants';
import { scrollIntoView } from 'shared/utils/dom';

export const scrollToTopChatHistory = () => {
  scrollIntoView(document.getElementById(CONTENT_TOP_ELEMENT_ID));
};
